import React from "react";

import { GenericTooltip } from "@components/tooltip-container";
import { type FetchMmmSummary_me_mmm_summary_accuracyData_data } from "@north-beam/nb-client-side";

import { type Kpi } from "../../explore-budgets/client-setting/types";

import { WeeklyAccuracyChart } from "./weekly-accuracy-chart";

interface Props {
  accuracyData: FetchMmmSummary_me_mmm_summary_accuracyData_data[];
  selectedKpi: Kpi;
}

export const SummaryWeeklyAccuracy = ({ accuracyData, selectedKpi }: Props) => (
  <div className="border rounded-lg py-2 px-4">
    <div className="mb-4">
      <GenericTooltip
        infoCircleClassName="text-sm"
        content="KPI values predicted before the period began compared to in-period actuals"
      >
        <span className="text-lg font-bold">Weekly accuracy</span>
      </GenericTooltip>
    </div>
    <WeeklyAccuracyChart
      accuracyData={accuracyData}
      selectedKpi={selectedKpi}
    />
  </div>
);
